import { Box, Dialog, Grid, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "styled-components";
import { Shortcut } from "components/Layout";

interface IProps {
  open: boolean;
  onClose: () => any;
}

const PageTitle = styled.legend`
  font-family: "Roboto", sans-serif;
  font-size: 24px;
  font-weight: 700;
`;

const Description = styled.p`
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  color: #414141;
  margin: 0px;
  padding: 0px;
`;

export const HelpDialog = ({ open, onClose }: IProps) => {
  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="help-dialog">
      <Box
        sx={{
          height: "570px",
          width: "530px",
          bgcolor: "#FFFFFF",
          borderRadius: "8px",
          p: 4,
          padding: "16px",
        }}
      >
        <Grid container spacing={0} alignContent={"center"}>
          <Grid item xs={11} style={{ display: "flex", alignItems: "center", margin: "0px" }}>
            <PageTitle>Keyboard shortcuts</PageTitle>
          </Grid>
          <Grid item xs={1} style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                color: "#414141",
              }}
            >
              <CloseIcon />
            </IconButton>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Select next</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
            <Shortcut>tab</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Select previous</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
            <Shortcut>shift</Shortcut>&nbsp;&nbsp;+&nbsp;&nbsp;<Shortcut>tab</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Pick up card</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>space</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Drop card</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>space</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Move card</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>&#8592;</Shortcut>&nbsp;
            <Shortcut>&#8593;</Shortcut>&nbsp;
            <Shortcut>&#8595;</Shortcut>&nbsp;
            <Shortcut>&#8594;</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Jump to first section in &#39;Unsorted&#39;</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>U</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Jump to first section in &#39;Exclude&#39;</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>E</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Jump to first section in the New Site Structure</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>S</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Close</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>esc</Shortcut>
          </Grid>
          <Grid item xs={8} style={{ display: "flex", justifyContent: "left", alignItems: "center" }}>
            <Description>Show keyboard shortcuts</Description>
          </Grid>
          <Grid item xs={4} style={{ display: "flex", justifyContent: "right", alignItems: "right" }}>
            <Shortcut>?</Shortcut>
          </Grid>
        </Grid>
      </Box>
    </Dialog>
  );
};
